import * as yup from "yup";
import {
  emailFieldvalidation,
  isNotFutureDateTest,
  isValidDateTest,
  maxLengthMessage,
} from "../../utils/functions";
import { RegularExpressions } from "../../utils/regular-expressions";

const applicantSchema = yup.object().shape({
  suffix: yup.string().trim().max(100, maxLengthMessage(100)).nullable(),
  lastName: yup
    .string()
    .trim()
    .matches(RegularExpressions.Name, "Invalid Last Name")
    .required("Last Name is required")
    .max(100, maxLengthMessage(100)),
  firstName: yup
    .string()
    .trim()
    .matches(RegularExpressions.Name, "Invalid First Name")
    .required("First Name is required")
    .max(100, maxLengthMessage(100)),
  middleName: yup.string().trim().matches(RegularExpressions.Name, "Invalid Middle Name").max(50, maxLengthMessage(50)).nullable(),
  dob: isValidDateTest("Date of Birth").concat(
    isNotFutureDateTest("Date of Birth")
  ),
  ssn: yup
    .string()
    .transform((value) => value?.replace(/\D/g, "") || "")
    .test(
      "ssn-length",
      "SSN should be of 9 digits",
      (value) => !value || value.length === 9
    ),
  ethnicity: yup.string().max(10, maxLengthMessage(10)).nullable(),
  gender: yup.string().max(10, maxLengthMessage(10)).nullable(),
  race: yup.string().max(2, maxLengthMessage(2)).nullable(),
  maritalStatus: yup.string().max(50, maxLengthMessage(50)).nullable(),
  phone: yup.string().trim().max(200, maxLengthMessage(200)).nullable(),
  email: emailFieldvalidation,
  workPhoneNum: yup.string().trim().max(200, maxLengthMessage(200)).nullable(),
  priorLawEnforcement: yup.boolean().nullable(),
  prepSchool: yup.boolean().nullable(),
  address: yup.string().trim().max(250, maxLengthMessage(250)).nullable(),
  city: yup.string().trim().max(100, maxLengthMessage(100)).nullable(),
  state: yup.string().max(50, maxLengthMessage(50)).nullable(),
  zip: yup.string().trim().max(15, maxLengthMessage(15)).nullable(),
  comments: yup.string().trim().max(500, maxLengthMessage(500)).nullable(),
  militaryRelatedNotes: yup
    .string()
    .trim()
    .max(500, maxLengthMessage(500))
    .nullable(),
  education: yup.string().trim().max(250, maxLengthMessage(250)).nullable(),
  pat: yup.string().max(10, maxLengthMessage(10)).nullable(),
  patDate: isValidDateTest("PAT Date"),
  written: yup.string().max(10, maxLengthMessage(10)).nullable(),
  writtenDate: isValidDateTest("Written Date"),
  polygraph: yup.string().max(10, maxLengthMessage(10)).nullable(),
  polygraphDate: isValidDateTest("Polygraph Date"),
  background: yup.string().max(10, maxLengthMessage(10)).nullable(),
  backgroundDateSent: isValidDateTest("Background Date"),
  backgroundDateReturned: isValidDateTest("Background Date Returned"),
  oralCommittee: yup.string().max(10, maxLengthMessage(10)).nullable(),
  oralCommitteeDate: isValidDateTest("Oral Interview Date"),
  oralDirector: yup.string().max(10, maxLengthMessage(10)).nullable(),
  oralDirectorDate: isValidDateTest("2nd Interview Date"),
  eligibility: yup
    .boolean()
    .nullable()
    .transform((value, originalValue) => (originalValue === "" ? null : value)),
  medical: yup.string().max(10, maxLengthMessage(10)).nullable(),
  medicalDate: isValidDateTest("Medical Date"),
  medicalNotes: yup
    .string()
    .trim()
    .max(1000, maxLengthMessage(1000))
    .nullable(),
  psych: yup.string().max(10, maxLengthMessage(10)).nullable(),
  psychDate: isValidDateTest("Psychological Exam Date"),
  boxNum: yup.string().trim().max(50, maxLengthMessage(50)).nullable(),
  yearApplied: yup.string().trim().max(50, maxLengthMessage(50)).required("Application Period is required").nonNullable(),
  status: yup.string().max(50, maxLengthMessage(50)).nullable(),
  testNotes: yup.string().max(1000, maxLengthMessage(1000)).nullable(),
  polygraphNotes: yup.string().trim().max(500, maxLengthMessage(500)).nullable(),
  oralDirectorNotes: yup
    .string()
    .trim()
    .max(500, maxLengthMessage(500))
    .nullable(),
  oralCommitteeNotes: yup
    .string()
    .trim()
    .max(500, maxLengthMessage(500))
    .nullable(),
  backgroundNotes: yup
    .string()
    .trim()
    .max(500, maxLengthMessage(500))
    .nullable(),
  wittenNotes: yup.string().trim().max(500, maxLengthMessage(500)).nullable(),
  patNotes: yup.string().trim().max(500, maxLengthMessage(500)).nullable(),
  backgroundInvestigator: yup.string().matches(RegularExpressions.Name, "Invalid Investigator Name").max(200, maxLengthMessage(200)).nullable(),
});

export default applicantSchema;
